export default __webpack_public_path__ + "static/media/GradientOutdoorTop.cee9b936.svg";